export const MIN_DATE_VALIDADE_LOTE_IMUNOBIOLOGICO_MESSAGE = 'Data de validade deve ser posterior ou igual à data atual'
export const MAX_DATE_VALIDADE_LOTE_IMUNOBIOLOGICO_MESSAGE = 'Data de validade deve ter no máximo 10 anos'
